import React from 'react';
import { Link } from 'react-router-dom';

const PRODUCT_LINKS = [
  { label: 'Search Cards', to: '/series' },
  { label: 'Collection Tracker', to: '/login' },
  { label: 'Price History', to: '/series' },
];

const COMPANY_LINKS = [
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
  { label: 'Privacy Policy', to: '/privacy' },
];

export default function AppFooter() {
  return (
    <footer className="border-t border-purple/20 bg-[#0d0f1a] pb-10 pt-12 font-landing-sans text-text-primary">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-12 grid grid-cols-2 gap-10 md:grid-cols-4">
          <div className="col-span-2">
            <Link to="/" className="mb-4 inline-flex items-center">
              <img src="/logo.png" alt="Lilycove Logo" className="h-11 w-auto" />
            </Link>
            <p className="max-w-sm text-text-secondary">
              The aggregator for Pokemon card collectors. Find better deals across marketplaces in one search.
            </p>
          </div>

          <div>
            <h4 className="mb-6 font-bold text-text-primary">Product</h4>
            <ul className="space-y-4 text-text-secondary">
              {PRODUCT_LINKS.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="transition-colors hover:text-brand-hi">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-6 font-bold text-text-primary">Company</h4>
            <ul className="space-y-4 text-text-secondary">
              {COMPANY_LINKS.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="transition-colors hover:text-brand-hi">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between border-t border-border-base pt-8 text-sm text-text-dim md:flex-row">
          <p>{`© ${new Date().getFullYear()} Lilycove. All rights reserved.`}</p>
          <p className="mt-4 md:mt-0">Not affiliated with Nintendo or The Pokemon Company.</p>
        </div>
      </div>
    </footer>
  );
}
